import { Box, Paper, Tab, Tabs } from '@mui/material'
import React from 'react'

import { IReduxState } from 'interfaces/IReduxState'
import { checkAccess } from 'shared/auth'
import { useSelector, useDispatch } from 'react-redux'

import CreatePurchaseOrder from './createPurchaseOrder'
import PurchaseOrderList from './purchaseOrderList'

export default function PurchaseOrderPage() {
  const [tabValue, setTabValue] = React.useState('1')

  const userGroups = useSelector((state: IReduxState) => state.userGroups || [])
  const groupAccessMapping = useSelector(
    (state: IReduxState) => state.groupAccessMapping
  )
  const hasCreateAccess = checkAccess(
    userGroups,
    groupAccessMapping,
    'purchaseOrder',
    'create'
  )

  const dispatch = useDispatch()
  React.useEffect(() => {
    dispatch({ type: 'SET_PAGE_TITLE', payload: 'Purchase Order' })
  }, [dispatch])

  return (
    <Box>
      <Paper>
        <Tabs
          scrollButtons="auto"
          value={tabValue}
          variant="scrollable"
          onChange={(e, newValue) => setTabValue(newValue)}
        >
          {hasCreateAccess && (
            <Tab value={'0'} label="Buat Purchase Order Baru" />
          )}
          <Tab value={'1'} label="Daftar Purchase Order" />
        </Tabs>
      </Paper>
      {hasCreateAccess && tabValue === '0' && (
        <Paper>
          <Box mt={2}>
            <CreatePurchaseOrder />
          </Box>
        </Paper>
      )}
      {tabValue === '1' && (
        <Paper>
          <PurchaseOrderList />
        </Paper>
      )}
    </Box>
  )
}
